import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import useFetchPaymentLinkAssociatedPaymentId from './hooks/useFetchPaymentLinkAssociatedPaymentId';
import PaymentLinkViewPaymentButton from './PaymentLinkViewPaymentButton';
// @ts-expect-error file not migrated yet
import propertyValueToNumber from 'customer-data-sidebar/universal/dataAccessHelpers/propertyValueToNumber';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useGetPaymentLinkChickletSecondaryDisplayLabels = ({
  properties,
  objectId,
  toObjectTypeId,
  onPreview,
  hasScope,
  fromObjectId,
  fromObjectTypeId
}) => {
  const {
    associatedPaymentId
  } = useFetchPaymentLinkAssociatedPaymentId(objectId, hasScope || (() => false), fromObjectId || 0, fromObjectTypeId || '');
  const amount = propertyValueToNumber(getPropertyValueFromProperties(properties, 'hs_total'));
  const renderCurrency = propertyDefinition => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.PaymentLinkChicklet.amount",
        useGap: true
      }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: toObjectTypeId,
        objectId: `${objectId}`,
        value: amount,
        getDraftValue: () => undefined,
        getSavedValue: propertyName => getPropertyValueFromProperties(properties, propertyName)
        // @ts-expect-error Known property issue as they have not updated the type definitions
        // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
        ,
        property: propertyDefinition
      })]
    });
  };
  const propertyFormatters = {
    hs_total: renderCurrency
  };
  return {
    propertyFormatters,
    copyDisabled: true,
    additionalPostfixContent: /*#__PURE__*/_jsx(PaymentLinkViewPaymentButton, {
      objectId: objectId,
      onPreview: onPreview,
      hasScope: hasScope || (() => false),
      sourceObjectId: fromObjectId || 0,
      sourceObjectTypeId: fromObjectTypeId || ''
    }),
    hideSecondaryDisplayLabels: !!associatedPaymentId
  };
};
export default useGetPaymentLinkChickletSecondaryDisplayLabels;